<script setup>
import { useRoute } from 'vue-router'
import { KkFreeItem } from '../../../components/domains/mapionBiz/'
const { company_uuid, store_uuid } = useRoute().params
const props = defineProps({
  attributes: {
    type: Object,
    required: true
  },
  searchGroups: {
    type: Array,
    required: true
  },
  bannerTemplate: {
    type: Object,
    required: false
  },
  isEditable: {
    type: Boolean,
    required: true
  },
  isDisplaySearchGroup: {
    type: Boolean,
    required: true
  },
  isDisplayTemplate: {
    type: Boolean,
    required: true
  },
})
</script>
<template>
  <div>
    <div class="mapionBiz">
      <div class="mapionBiz__item">
        <div class="mapionBiz__info">
          <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.latitude') }}</p>
          <p class="mapionBiz__content">{{ props.attributes.latitude }}</p>
          <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.longitude') }}</p>
          <p class="mapionBiz__content">{{ props.attributes.longitude }}</p>
        </div>
        <div class="mapionBiz__info">
          <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.profile.extraName') }}</p>
          <p class="mapionBiz__content">{{ props.attributes.profile.extraName }}</p>
        </div>
        <div class="mapionBiz__info">
          <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.profile.notice') }}</p>
          <p class="mapionBiz__content">{{ props.attributes.profile.notice }}</p>
        </div>
        <div class="mapionBiz__info">
          <p class="mapionBiz__name">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.profile.regularHourDescription') }}</p>
          <p class="mapionBiz__content">{{ props.attributes.profile.regularHourDescription }}</p>
        </div>
        <div v-if="props.isEditable" class="c-button c-button--right">
          <router-link
            :to="{ name: 'CompaniesLocationStoreMapionBizEdit', params: { company_uuid, store_uuid } }"
            class="c-button__item c-button__item--primary"
          >
            {{ $t('labels.change') }}
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="props.isDisplaySearchGroup" class="p-box">
      <div class="p-box__body">
        <span class="fontBold">{{ $t('pages.CompaniesLocationStore.mapionBizAttributes.searchGroup.title') }}</span>
        <div v-for="(searchGroup, i) in props.searchGroups" :key="'searchGroup_' + i">
          <div class="searchGroupContainer">
            <span class="searchGroupContainer__name">{{ searchGroup.name }}</span>
            <div class="conditionContainer">
              <template v-for="(condition, j) in searchGroup.conditions" :key="`searchGroup_${ i }_condition_${ j }`">
                <div class="conditionContainer__wrap">
                  <div v-if="condition.image" class="conditionContainer__image">
                    <img :src="condition.image" alt="">
                  </div>
                  <div class="conditionContainer__contents">
                    {{ condition.name }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="props.isEditable" class="c-button c-button--right">
          <router-link
            :to="{ name: 'CompaniesLocationStoreMapionBizSearchGroupsEdit', params: { company_uuid, store_uuid } }"
            class="c-button__item c-button__item--primary"
          >
            {{ $t('labels.change') }}
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="props.bannerTemplate && props.isDisplayTemplate">
      <!-- フリー項目 - ヘッダー -->
      <template v-for="(headerItem, i) in props.bannerTemplate.headers" :key="i">
        <KkFreeItem
          :display-area="$t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.upper')"
          :kind="headerItem.kind"
          :title="headerItem.name"
          :content="headerItem.body || headerItem.text"
          :url="headerItem.url"
          :alt="headerItem.alt"
          :img="headerItem.image"
          :icons="headerItem.icons"
        />
      </template>
      <!-- フリー項目 - フッター -->
      <template v-for="(footerItem, i) in props.bannerTemplate.footers" :key="i">
        <KkFreeItem
          :display-area="$t('pages.CompaniesLocationStore.mapionBizAttributes.freeItems.bottom')"
          :kind="footerItem.kind"
          :title="footerItem.name"
          :content="footerItem.body || footerItem.text"
          :url="footerItem.url"
          :alt="footerItem.alt"
          :img="footerItem.image"
          :icons="footerItem.icons"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mapionBiz {
  &__item {
    padding: 0 32px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__info {
    padding: 24px 0;
    border-bottom: 1px solid #E4E7EB;
  }
  &__name {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__title {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 16px;
  }
  &__content {
    font-size: 14px;
    line-height: 1.5;
  }
  &__multiple {
    display: flex;
    &__img {
      width: 20%
    }
  }
  .c-button {
    align-self: center;
    margin-top: 0;
    padding: 32px 0;
    &__item {
      margin: 0;
    }
  }
}
.searchGroupContainer {
  padding: 12px;
  border-bottom: 1px solid #E4E7EB;
  &__name {
    font-weight: bold;
  }
  .conditionContainer {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    &__wrap {
      display: flex;
      margin-right: 15px;
    }
    &__name {
      font-weight: bold;
    }
    &__contents {
      font-size: 14px;
      display: flex;
      align-items: center;
    }
    &__image {
      margin-right: 10px;
      img {
        border: 1px solid #E4E7EB;
        border-radius: 4px;
        width: 60px;
        height: 60px;
      }
    }
  }
}
.fontBold {
  font-weight: bold;
}
</style>
